import { render, staticRenderFns } from "./NumberValue_1.vue?vue&type=template&id=5af46dca&scoped=true&"
import script from "./NumberValue_1.vue?vue&type=script&lang=js&"
export * from "./NumberValue_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af46dca",
  null
  
)

export default component.exports